export default __webpack_public_path__ + "fonts/401f44c72818fcd13083e72f77ab62f2.eot";